import colors from "../base/colors";
import typography from "../base/typography";

import pxToRem from "../functions/pxToRem";

const { primary, secondary, info, success, warning, error, text, white, grey } = colors;
const { fontWeightBold } = typography;

const badge = {
  styleOverrides: {
    badge: {
      fontWeight: fontWeightBold,
      fontSize: pxToRem(10),
      minWidth: pxToRem(18),
      height: pxToRem(18),
      padding: `0 ${pxToRem(6)}`,
    },
    colorPrimary: {
      backgroundColor: primary.main,
      color: primary.contrastText,
    },
    colorSecondary: {
      backgroundColor: secondary.main,
      color: secondary.contrastText,
    },
    colorInfo: {
      backgroundColor: info.main,
      color: info.contrastText,
    },
    colorSuccess: {
      backgroundColor: success.main,
      color: success.contrastText,
    },
    colorWarning: {
      backgroundColor: warning.main,
      color: warning.contrastText,
    },
    colorError: {
      backgroundColor: error.main,
      color: error.contrastText,
    },
    standard: {
      backgroundColor: grey[600],
      color: white.main,
    },
    dot: {
      backgroundColor: error.main,
    },
  },
};

export default badge;
